const LoadingHeader = () => (
  <div className="flex animate-pulse space-x-4">
    <div className="h-6 w-[250px] rounded bg-slate-200 dark:bg-slate-700" />
  </div>
);
export default LoadingHeader;
